import { select } from "redux-saga/effects";

import type { TransformationMapSetInnerNodeAction } from "domains/transformationMap/actionTypes";
import { getTmId } from "domains/transformationMap/selectors";
import { router } from "router/router";

export function* updateKeyIssueSaga(action: TransformationMapSetInnerNodeAction) {
  const { id } = action.meta;
  const { pathname } = location;

  const isCurrentlyKeyIssuePath = pathname.includes("key-issues");
  const storedTopicId: ReturnType<typeof getTmId> = yield select(getTmId);

  const topicId = action.meta.topicId ?? storedTopicId;
  if (!topicId) return;

  const productDomain = pathname.split("/")[1];
  if (!["topics", "discover", "create"].includes(productDomain)) return;

  const url = id
    ? `/${productDomain}/${topicId}/key-issues/${id}`
    : isCurrentlyKeyIssuePath
      ? `/${productDomain}/${topicId}`
      : undefined;

  if (url !== undefined && url !== pathname) yield router.navigate(url);
}
